import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as EditPencilIcon } from '../../../../assets/images/EditPencilIcon.svg';
import { sortYear } from '../../../../helpers/commonHelper';

import styles from './Experience.module.scss';

const ExperienceDetails = ({ experienceData, allowEdit, handleOpenModal }) => {
  const { t } = useTranslation('common');
  const [sortedData, setSortedData] = useState([]);

  useEffect(() => {
    if (experienceData) {
      const filtered = experienceData.filter(({ current_position }) => current_position);
      const remaining = experienceData.filter(({ current_position }) => !current_position);

      filtered.sort((data1, data2) => sortYear(data1.start_year, data2.start_year));
      remaining.sort((data1, data2) => sortYear(data1.end_year, data2.end_year));

      setSortedData([...filtered, ...remaining]);
    }
  }, [experienceData]);

  return sortedData.map((data, counter) => {
    const { id, job_title, company, location, start_year, end_year, current_position, description } = data;
    return (
      <div key={`${id}-exp`}>
        <div className={styles.jobTitle}>
          {job_title}
          {allowEdit && (
            <div>
              <button className={styles.addExperience} type="button" onClick={() => handleOpenModal(data)}>
                <EditPencilIcon />
              </button>
            </div>
          )}
        </div>
        <div className={styles.fadeText}>
          <div className={styles.company}>{company}</div>
          <div className={styles.location}>{location}</div>
          <div className={styles.startDate}>
            {start_year} {t('to')} {current_position ? t('present') : end_year}
          </div>
        </div>
        <div className={styles.jobDescription}>{description}</div>
        {counter !== experienceData.length - 1 && <div className={styles.endLine} />}
      </div>
    );
  });
};

export default ExperienceDetails;
